// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"b418fbd7","152":"1c426f66","226":"a08d3d0f","301":"d44bcd5a","354":"48be3e50","453":"9544ec61","509":"8e07b9b9","557":"ffa84bf1"}[chunkId] + ".chunk.js";
};